import ExcelJS from "exceljs";
import { Observable } from "rxjs";
import { BaseExcelDocumentBuilder } from "./BaseExcelDocumentBuilder.js";
class XlsxDocumentBuilder extends BaseExcelDocumentBuilder {
  parseFile(file, columns) {
    const reader = new FileReader();
    return {
      resultObservable: new Observable((subscriber) => {
        const workbook = new ExcelJS.Workbook();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          workbook.xlsx.load(reader.result).then((workbook2) => {
            const result = [];
            try {
              workbook2.eachSheet((sheet) => {
                if (sheet.state === "visible") {
                  result.push(...this.parseDataSheet(sheet, columns));
                }
              });
              subscriber.next(result);
              subscriber.complete();
            } catch (e) {
              subscriber.error(e);
            }
          }).catch((e) => {
            subscriber.error(e);
          });
        };
        reader.onerror = (error) => subscriber.error(error);
      }),
      onCancel: () => {
        reader.abort();
      }
    };
  }
  getDocument() {
    const result = this.workbook.xlsx;
    this.reset();
    return result;
  }
}
export {
  XlsxDocumentBuilder
};
//# sourceMappingURL=XlsxDocumentBuilder.js.map
